<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
      <strong>Eventos masivos</strong>
    </h2>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div
            class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;"
          >
            <div class="text-left">
              <mdb-tooltip material trigger="hover" v-if="role !=='Capturista'" :options="{placement: 'top'}">
                <span slot="tip">Crear evento</span>
                <a slot="reference" href="/create">
                  <img
                    alt="crear evento"
                    class="mt-0"
                    src="../../../static/Crear_BTN@3x.png"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;"
                  />
                </a>
              </mdb-tooltip>
            </div>
            <span
              class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; margin-left: 10%;"
            >Eventos creados</span>

            <div class="text-right">
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Descargar invitaciones</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="downloadInvitations"
                >
                  <mdb-icon icon="download" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" v-if="role !=='Capturista'" :options="{placement: 'top'}">
                <span slot="tip">Clonar evento</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="cloneEvent"
                >
                  <mdb-icon icon="clone" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" v-if="role !=='Capturista'" :options="{placement: 'top'}">
                <span slot="tip">Editar evento</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="editEvent"
                >
                  <mdb-icon icon="pencil-alt" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" v-if="role !=='Capturista'" :options="{placement: 'top'}">
                <span slot="tip">Cancelar evento</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="cancelEvent"
                >
                  <mdb-icon icon="ban" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" v-if="role !=='Capturista'" :options="{placement: 'top'}">
                <span slot="tip">Eliminar evento</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="removeEvent"
                >
                  <mdb-icon icon="trash" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
            </div>
          </div>
          <!--/Card image-->

          <div class="px-4">
            <div >
              <mdb-datatable
                :data="data"
                :borderless="true"
                responsive
                :tfoot="false"
                :arrows="true"
                :display="10"
                striped
                bordered
                :sorting="true"
                searchPlaceholder="Buscar"
                noFoundMessage="No se encontraron registros de eventos"
                showingText="Mostrando"
                class="table table-responsive massiveEventsTable"
                id="dataTableBuilder"
                style="display: contents;"
              />
            </div>

            <!--Bottom Table UI-->
          </div>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardText,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbCardHeader,
  mdbListGroup,
  mdbListGroupItem,
  mdbDatatable
} from "mdbvue";

export default {
  name: "MassiveEventos",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbCardHeader,
    mdbListGroup,
    mdbListGroupItem,
    mdbDatatable
  },
  data() {
    return {
      eventsSelected: [],
      reactiveTable: false ,
      role:'',
      urlServer: Servers.serverApi,
      week: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      month: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      data: {
        columns: [
          {
            label: '',
            field: 'checkbox',
            sort: 'asc'
          },
          {
            label: 'Nombre del evento',
            field: 'name',
            sort: 'asc'
          },
          {
            label: 'Cantidad de invitados',
            field: 'guests',
            sort: 'asc'
          },
          {
            label: 'Fecha',
            field: 'date',
            sort: 'asc'
          },
          {
            label: 'Hora',
            field: 'time',
            sort: 'asc'
          },
          {
            label: 'Estatus',
            field: 'status',
            sort: 'asc'
          }
        ],
        rows: []
      }
    };
  },
  methods: {
    removeEvent() {
      let aux = this;
      aux.makeListOfEvents();
      if (aux.eventsSelected.length > 0) {
        aux.eventsSelected.map(function(value, key) {
          if (
            value.status === "Terminado" ||
            value.status === "Cancelado" ||
            value.status === "Incompleto"
          ) {
            Swal.fire({
              title:
                "<span style='font-size: 16px; font-family: OpenSans-Regular;'>¿Seguro que deseas eliminar éste evento?</span>",
              html:
                "<span style='font-size: 12px'>El evento se eliminará permanentemente y las invitaciones para este evento quedarán inválidas. </span>",
              imageUrl: "../../../static/Delete_Icon.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              showCancelButton: true,
              confirmButtonText: "Eliminar",
              cancelButtonText: "Cancelar",
              reverseButtons: true,
              customClass: {
                confirmButton: "btn-modal-accept",
                cancelButton: "btn-modal-cancel"
              }
            }).then(result => {
              if (result.value) {
                Axios.delete(
                  aux.urlServer + "api/massiveEvents/" + value.uuid,
                  {
                    responseType: "application/json",
                    headers: {
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token")
                    }
                  }
                ).then(
                  function(response) {
                    aux.reactiveTable = true;
                    aux.showMessageSucces("Evento eliminado correctamente");
                  },
                  function(error) {
                    aux.showMessageError("Ha ocurrido un error", error.data);
                    return false;
                  }
                );
              }
            });
          } else {
            Swal.fire({
              title:
                "<span style='font-size: 20px'>No se puede realizar la siguiente acción</span>",
              html:
                "<span style='font-size: 12px'>No se puede eliminar un evento que no ha terminado <strong> \" " +
                value.title +
                ' " </strong> ya que el evento tiene estatus de <strong>próximo o en curso</strong>.</span>',
              imageUrl: "../../../static/Copy_icon@3x.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              }
            });
          }
        });
      }
       else{
        aux.showMessageInfo("Para realizar esta acción, asegúrate de seleccionar un evento.");
      }
    },
    getDataTable() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/massiveEvents/", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          response.data.map(function(value, key) {
            let event = value[0]
            var object = {
              checkbox:
                '<input class="form-check-input" type="checkbox" id="checkboxEvent_' +
                event.uuid +
                '" data-uuid=' +
                event.uuid +
                " data-invited=" +
                event.uuid +
                " data-title='"+event.title+"' data-status=" +
                aux.getStatus(event.startDate, event.endDate, event.status) +
                '><label for="checkboxEvent_' +
                event.uuid +
                '" class="label-table"></label>',
              name: event.title,
              guests: aux.getStatus(event.startDate, event.endDate, event.status) === 'Terminado' || aux.getStatus(event.startDate, event.endDate, event.statu) === 'Cancelado' || aux.getStatus(event.startDate, event.endDate, event.statu) === 'Incompleto' ? parseInt(value[1]):'<div class="tooltip-p"><a href="./guests?event='+event.uuid+'" style=" color: cornflowerblue; text-decoration: underline;">'+parseInt(value[1])+'</a><span class="tooltiptext">Ver invitados</span></div>',
              date: aux.DateToSpanish(event.startDate),
              time: aux.$moment(new Date(event.startDate)).format('LT'),
              status: aux.getStatus(event.startDate, event.endDate, event.status)
            };
            aux.data.rows.push(object);
          });
        });
    },
    getStatus(value, value2, status) {
      const currentDate = new Date();
      const eventDate = new Date(value);
      const endDate = new Date(value2);
      if (eventDate < currentDate && status !== 'Cancelado' && status !== 'Incompleto') {
        if(endDate > currentDate){
          return "En curso"
        }
        else{
          return "Terminado";
        }
      } else {
          return status;
      }
    },
    DateToSpanish(date) {
      const index = this.$moment(new Date(date)).format('LLLL').lastIndexOf(' ');
      return this.$moment(new Date(date)).format('LLLL').substring(0, index)

    },
    downloadInvitations() {
      let aux = this;
      this.makeListOfEvents();
      if (this.eventsSelected.length > 0) {
        var type = "application/zip";
        var downloadName = "invitaciones.zip";
        var ContentType = "multipart/form-data";
        this.eventsSelected.map(function(value, key) {
          if (
            value.status === "Terminado" ||
            value.status === "Incompleto" ||
            value.status === "Cancelado"
          ) {
            Swal.fire({
              title:
                "<span style='font-size: 20px'>No se puede realizar la siguiente acción</span>",
              html:
                "<span style='font-size: 12px'>Los eventos con estatus \"<strong>Cancelado, Incompleto o Terminado</strong>\" no pueden ser descargados</span>",
              imageUrl: "../../../static/Alerta_icon@3x.pngº",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              }
            });
          } else {
            Swal.showLoading("Descargando...");
            if (value.numInvited === "1") {
              type = "image/png";
              downloadName = "invitacion.png";
              ContentType = "image/png";
            }
            Axios.get(
              aux.urlServer + "api/massiveEvents/" + value.uuid + "/invitation",
              {
                responseType: "arraybuffer",
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": ContentType
                }
              }
            )
              .then(response => {
                let blob = new Blob([response.data], { type: type });
                const downloadUrl = URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = downloadUrl;
                a.download = downloadName;
                document.body.appendChild(a);
                a.click();
                Swal.hideLoading();
                 Swal.fire({
                  title: "<span style='font-size: 20px;'>Descarga completada</span>",
                  width: "20%",
                  allowOutsideClick: false,
                  showConfirmButton: true,
            });
              })
              .catch(error => {
                console.log(error.response);
                aux.showMessageError(
                  "Ha ocurrido un error",
                  error.response.data
                );
              });
          }
        });
      }
      else{
        aux.showMessageInfo("Para realizar esta acción, asegúrate de seleccionar un evento.");
      }
    },
    cloneEvent() {
      let aux = this;
      aux.makeListOfEvents();
      if (aux.eventsSelected.length > 0) {
        aux.eventsSelected.map(function(value, key) {
          if (value.status === "Terminado") {
            Axios.post(
              aux.urlServer + "api/massiveEvents/" + value.uuid + "/clone",
              null,
              {
                responseType: "application/json",
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token")
                }
              }
            )
              .then(response => {
                aux.reactiveTable = true;
                aux.showMessageSucces("Evento clonado correctamente");
              })
              .catch(error => {
                console.log(error.response);
                aux.showMessageError(
                  "Ups...",
                  "No se puede clonar este evento, solo es posible clonar eventos con estatus \"Terminado\"."
                );
              });
          } else {
            Swal.fire({
              title:
                "<span style='font-size: 16px; font-family: OpenSans-Regular;'>No se puede realizar la siguiente acción</span>",
              html:
                "<span style='font-size: 12px'>No se puede clonar el evento <strong> \" " +
                value.title +
                ' " </strong> ya que el evento tiene estatus de <strong>próximo, incompleto, cancelado o en curso</strong>.</span>',
              imageUrl: "../../../static/Copy_icon@3x.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept"
              }
            });
          }
        });
      }
       else{
        aux.showMessageInfo("Para realizar esta acción, asegúrate de seleccionar un evento.");
      }
    },
    cancelEvent() {
      let aux = this;
      aux.makeListOfEvents();
      if (aux.eventsSelected.length > 0) {
      Swal.fire({
        title:
           "<span style='font-size: 16px; font-family: OpenSans-Regular;'>¿Seguro que deseas cancelar éste evento?</span>",
        html:
           "<span style='font-size: 12px'>El evento se cancelará y las invitaciones para este evento quedarán inválidas. </span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        customClass: {
          confirmButton: "btn-modal-accept",
          cancelButton: "btn-modal-cancel"
        }
      }).then(result => {
        if (result.value) {
            aux.eventsSelected.map(function(value, key) {

              if (
                value.status === "Cancelado" ||
                value.status === "Terminado" ||
                value.status === "En"
              ) {
                aux.showMessageError(
                  "No se puede cancelar un evento que ya ha sido cancelado, terminado o se encuentra en curso",
                  ""
                );
              } else {
                Axios.put(
                  aux.urlServer + "api/massiveEvents/" + value.uuid + "/cancel",
                  null,
                  {
                    responseType: "application/json",
                    headers: {
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token")
                    }
                  }
                )
                  .then(response => {
                    aux.reactiveTable = true;
                    aux.showMessageSucces("Evento cancelado correctamente");
                  })
                  .catch(error => {
                    console.log(error.response);
                    aux.showMessageError("Ha ocurrido un error", error.response.data);
                  });
              }
            });
          
        }
      });
    }
     else{
        aux.showMessageInfo("Para realizar esta acción, asegúrate de seleccionar un evento.");
      }
    },
    editEvent() {
      let aux = this;
      aux.makeListOfEvents();
      if (this.eventsSelected.length > 0) {
        if (this.eventsSelected.length == 1) {
          this.eventsSelected.map(function(value, key) {
            if (value.status == "Próximo" || value.status == "Incompleto"){
               window.location.href = "./create?token=" + value.uuid;
            } else {
              Swal.fire({
                title:
                  "<span style='font-size: 20px'>No se puede realizar la siguiente acción</span>",
                html:
                  "<span style='font-size: 12px'>Los eventos con estatus:  \"<strong>cancelado, terminado o en curso</strong>\" no pueden ser editados</span>",
                imageUrl: "../../../static/Alerta_icon@3x.png",
                imageWidth: "22%",
                imageHeight: "auto",
                width: "30%",
                confirmButtonText: "Aceptar",
                customClass: {
                  confirmButton: "btn-modal-accept"
                }
              });
            }
          });
        } else {
          this.showMessageError(
            "No es posible editar más de un evento a la ves",
            ""
          );
        }
      }
       else{
        aux.showMessageInfo("Para realizar esta acción, asegúrate de seleccionar un evento.");
      }
    },
    makeListOfEvents() {
      let aux = this;
      aux.eventsSelected = [];
      var arr = Array.prototype.slice.call(
        document.getElementsByClassName("form-check-input")
      );
      arr.map(function(value, key) {
        if (value.checked) {
          aux.eventsSelected.push({
            uuid: value.dataset.uuid,
            numInvited: value.dataset.invited,
            status: value.dataset.status,
            title: value.dataset.title
          });
        }
      });
    },
    getOneEvent(uuid) {
      let aux = this;
      return Axios.get(this.urlServer + "api/massiveEvents/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          var result = response.data;
          return result;
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
          window.location.reload();
        }
      });
    },
    showMessageInfo: function(text){
       Swal.fire({
        title: "<span style='font-size: 14px;'>" + text + "</span>",
        type: "info",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
      });

    },
  },
  created(){
   this.role = localStorage.getItem("role");
    this.getDataTable();

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>


.massiveEventsTable{
  display: inline-block

}
.massiveEventsTable div.dataTables_filter {
  float: left;
  margin-bottom: 0px;
}
.dataTableBuilder_filter label {
  display: none;
}
.massiveEventsTable div.dataTables_filter input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-bottom: 2rem;
  display: inline-block;
  width: 300px ;
  border-radius: 25px ;
  height: 15px ;
  padding-left: 35px ;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular" ;
  font-size: 12px ;
  color: #fff;
  background: url('../../../static/zoom_in.png')
    no-repeat scroll 12px 7px #67a3cf ;
  background-size: 20px 20px ;
}

div.dataTables_wrapper div.dataTables_length {
  display: none !important;
}

.massiveEventsTable  div.dataTables_filter input[search]:focus {
  font-size: 12px;
}

.md-form input[type="search"]:focus:not([readonly]) {
  -webkit-box-shadow: 0 0px 0 0 transparent !important;
  box-shadow: unset;
  border-bottom: unset;
  outline: none !important;
}

div.dataTables_wrapper div.dataTables_filter input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ffffff !important;
  opacity: 1; /* Firefox */
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}


.dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  cursor: default;
  color: #666 !important;
  border-radius: 10px !important;
  background: transparent;
  box-shadow: none;
  font-family: "OpenSans-Light" !important;
  font-size: 12px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  box-sizing: border-box;
  display: inline-block;
  min-width: 1.5em;
  margin-left: 2px;
  text-align: center;
  text-decoration: none !important;
  cursor: pointer;
  color: #333 !important;
  border: 1px solid transparent;
  border-radius: 5px;
  padding: 0px !important;
  margin-left: 14px !important;
}


.massiveEventsTable .dataTables_paginate {
  width: 600px ;
  float: none ;
  margin: 0 auto ;
}

.massiveEventsTable div.dataTables_paginate {
  display: block ;
  margin-left: auto ;
  margin-right: auto ;
  float: none ;
  text-align: center ;
}

#dataTableBuilder_previous > a,
#dataTableBuilder_next > a {
  height: 30px !important;
}


div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
  position: absolute;
  top: 60px;
  font-family: "OpenSans-Light" !important;
  display: none !important;
}


table.dataTable tbody tr {
  background-color: #ffffff !important;
}

.table > thead:first-child > tr:first-child > th {
  border-top: 0;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center;
}



</style>


<style scoped>
/* --------------------------------------------------------
 /* ---- INTERIOR
 -------------------------------------------------------- */


.searchIcon {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 999;
  top: 16px;
  left: 26px;
}

.searchIcon img {
  width: 100%;
  height: auto;
}


.table{
  text-align: center !important;
}

.table > thead > tr > th {
  text-align: center !important;

}



.table > thead > tr > th:nth-child(1) > .sorting{
  display: none !important;
}

.table > thead > tr > th:nth-child(2){
  text-align: justify !important;
}
.table > tbody > tr > td:nth-child(2) {
  text-align: justify !important;
}

/*
.table > tbody > tr > td:nth-child(3) {
  text-align: center !important;
}
.table > tbody > tr > td:nth-child(1) {
  text-align: center !important;
}
.table > thead > tr > th:nth-child(3){
  text-align: center !important;
}
.table > thead > tr > th:nth-child(4){
  text-align: center !important;
}*/

.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 2px solid #f6f6f6;
  font-family: "OpenSans-Regular" !important;
  font-size: 12px;
  color: #000000 !important;
}


.pagination > .active > a, 
.pagination > .active > span {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #67a3cf !important;
  border-color: #707070 !important;
}

/*
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #bce0fd !important;
  border-color: #707070 !important;
}

.pagination > li > a,
.pagination > li > span {
  position: relative;
  float: left;
  padding: 4px 16px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #999;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #999;
  border-radius: 4px;
}

.pagination > li > a:hover {
  border: 1px solid #999 !important;
  color: #999 !important;
  background: #bce0fd !important;
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  background: #bce0fd !important;
  border-color: #f6f6f6 !important;
}*/

.paginate_button {
  background: #f6f6f6 !important;
}



.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #23a7ed !important;
  font-size: 12px !important;
  border-radius: 7px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #ed5f5f !important;
  font-size: 12px !important;
  border-radius: 7px !important;
}

.Rect-BG {
  width: 112%;
  height: 44px;
  background-color: #67a3cf;
  margin-left: -6%;
  margin-bottom: 20px;
  margin-top: -20px;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
